module.exports = __webpack_public_path__ + "static/media/orangeDrawing.ea591dcc.jpg";